import { environment } from "../../environments/environment";
import { LanguageData as TextData_NL } from "./nl";
import { LanguageData as TextData_EN } from "./en";

export default function translations(): ITranslations {
  switch (environment.language) {
    case 'NL': return TextData_NL;
    case 'EN': return TextData_EN;
    default:
      throw Error('incorrect language setting');
  }
}

export function languageSwitchData() {
  switch (environment.language) {
      case 'EN':
        return {
          caption: translations().login.dutch,
          link: environment.domains.nl
       }
      case 'NL':
        return {
          caption: translations().login.english,
          link: environment.domains.en
       }
  }

}

export interface ITranslations {
  login: {
    login: string;
    forgetPassword: string;
    colofon: string;
    manualDownload: string;
    inschrijven: string;
    benjenieuwhier: string;
    klaar: string;
    username: string;
    password: string;
    dutch: string;
    english: string;
  }
  , global: {
    back: string;
    continue: string;
    next: string;
    done: string;
    playagain: string;
  },
  register: {
    subscribe: string;
    requiredFields: string;
    passwordConfirm: string;
    emailAddress: string;
  },
  createAvatar: {
    chooseYourAvatar: string;
    skinLight: string;
    skinMiddle: string;
    skinDark: string;
    remarks: string;
  },
  dashboard: {
    logout: string;
    chooseItem: string;
  },
  diploma: {
    thisisforyou: string;
    instruction: string;
    send: string;
    ready: string;
  },
  games: {
    instruction: string;
    goodbad: string;
    bad: string;
    good: string;
    helpingToughts: string;
    questions: string;
    chooseEmotion: string;
    stresshead: string;
    moveArrow: string;
    wellDone: string;
    title_GameVideo:string;
    title_GameClicker: string;
    title_GameMultipleChoice: string;
    title_GameMemory: string;
    title_GameHelpendeGedachten: string;
    title_GameStresshoofd:string;
    title_GameGoodBad: string;
    clicker_response_plural: string;
    clicker_response: string;
    clicker_beginner: string;
    clicker_expert: string;
    print_worksheet: string;
  }
}
